module.exports = __webpack_public_path__ + "img/Bad-Check.7b52d056.svg";